import * as React from 'react';
import { Controller, UseControllerReturn, useFormContext } from 'react-hook-form';
import { CheckboxGroup, ICheckboxGroupProps, IkeyType, Label, StackPanelOrientation } from '@agilepoint/wat-react-ux';
import { memoizeFunction } from '@agilepoint/utils-common';
import { IBaseFormFieldProps, FieldBlock, StyledErrorMessage } from '@agilepoint/wat-react-ux-form-fields';
import { ErrorMessage } from '@hookform/error-message';

interface ICheckboxGroupFormFieldProps extends IBaseFormFieldProps, Omit<ICheckboxGroupProps, 'name' | 'label'> {
    fieldOrientation?: StackPanelOrientation
}

const createOnChangeProxy = memoizeFunction((onChange: any) =>
    (selectedKeys: IkeyType[]) => onChange(selectedKeys)
);

export function CheckboxGroupField(props: ICheckboxGroupFormFieldProps) {
    const { className, name, label, validationRules, defaultCheckedKeys, fieldOrientation, gap, title, ...restProps } = props;
    const { control, formState: { errors } } = useFormContext();
    const hasError = name in errors;

    const renderCheckBoxGroup = React.useCallback(({ field: { onChange, value } }: UseControllerReturn) => (
        <CheckboxGroup {...restProps} onValueChange={createOnChangeProxy(onChange)}
            checkedKeys={value} error={hasError} />
    ), [hasError, restProps]);

    return (
        <FieldBlock gap={gap} orientation={fieldOrientation} className={className} title={title}>
            {label ? <Label required={validationRules && !!validationRules.required}>{label}</Label> : <></>}
            <Controller control={control} name={name} defaultValue={defaultCheckedKeys}
                render={renderCheckBoxGroup} rules={validationRules} />
            <ErrorMessage errors={errors} name={name} as={StyledErrorMessage} />
        </FieldBlock>
    );
}
